import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect } from "react";
import { json, Link, useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format, parse } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowDropUp, ArrowRightAltRounded, CalendarMonthOutlined, CopyAllOutlined, DownloadOutlined, MovingRounded, OnlinePredictionOutlined, OnlinePredictionRounded, PeopleAltRounded, PeopleOutlineRounded, Person2Rounded, StarRateRounded, TodayOutlined } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import CustomCarousel from "../Utils/CustomSlider";
import { ClockIcon } from "@mui/x-date-pickers";
import * as XLSX from "xlsx";

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const CommunityMembers = () => {

    const theme = useTheme();
    const query = useQuery()
    const colors = tokens(theme.palette.mode);
    const [communityDetail, setCommunityDetail] = useState({})
    const [communityBasics, setCommunityBasics] = useState({})
    const [users, setUsers] = useState([])
    const [userActivity, setUserActivity] = useState([])
    const [hasEnded, setHasEnded] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(30)
    const [activityStatus, setActivityStatus] = useState({})
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [invalidUsers, setInvalidUsers] = useState([])
    const [communityMail, setCommunityMail] = useState("")
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedDateMembers, setSelectedDateMembers] = useState([])



    const Convert_Time_Zone = (isostring) => {
        const isoString = isostring;
        const desiredFormat = "dd MMMM yyyy, hh:mm:ss a";

        const indianTimeZone = "Asia/Kolkata";
        const zonedTime = utcToZonedTime(isoString, indianTimeZone);

        const formattedDate = format(zonedTime, desiredFormat, {
            timeZone: indianTimeZone,
        });

        return formattedDate;
    };

    const Convet_Date_To_Supported_Date = (input) => {
        const parsedDate = parse(input, "dd-MMM-yyyy", new Date());
        return format(parsedDate, "yyyy-MM-dd");
    };

    const exportToExcel = async () => {
        const sortedUsers = [...invalidUsers].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        const dataToExport = sortedUsers.map(user => ({
            "Full Name": user.userId?.full_name || "",
            "Buzz Name": user.userId?.buzz_name || "",
            "Community Mail": user.communityMail || "",
            "Status": user.userId?.Active ? "Deleted" : "InActive",
            "Joined": new Date(user.createdAt).toLocaleString()
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);

        // 👉 Calculate max width for each column
        const columnWidths = Object.keys(dataToExport[0]).map((key) => {
            const maxLength = Math.max(
                key.length,
                ...dataToExport.map(row => (row[key] ? row[key].toString().length : 0))
            );
            return { wch: maxLength + 2 }; // +2 for some padding
        });

        worksheet['!cols'] = columnWidths; // ⬅️ Apply column widths

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Invalid Users");

        XLSX.writeFile(workbook, "Invalid_Users.xlsx");
    };


    const FetchCommunityDetail = async (page) => {
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/getmembersdetail/${query.get('community')}?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setLoading(false)

            if (page == 1) {
                setCommunityBasics(data.response[0].community)
                setUsers(data.response)
                setUserActivity(data.activity)
            } else {
                setUsers(prev => [...prev, ...data.response])
                setUserActivity(prev => [...prev, ...data.activity])
            }

            if (data.response.length > 0) {
                setCurrentPage(page)
            }

            if (data.response < limit) {
                setHasEnded(true)
            }
        } else {
            alert(data.response)
            setLoading(false)
        }
    };

    const FetchActivityData = async () => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/getmembersactivitydetail/${query.get('community')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();

        if (data.success === true) {
            setActivityStatus(data)
        }
    };

    const FetchActivityDataByDate = async (date) => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/getmembersactivitybydate/${query.get('community')}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
            body: JSON.stringify({
                date: date
            })
        });
        const data = await response.json();

        console.log(data)

        if (data.success === true) {
            setSelectedDateMembers(data.users)
        }
    };


    const FetchInvalidUsers = async () => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/getinvalidusers/${query.get('community')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();

        console.log(data)
        if (data.success === true) {
            setInvalidUsers(data.response)
        }
    };


    const deleteUser = async (mail) => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/removeuserfromcommunity/${query.get('community')}/${mail}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setCommunityMail("")
        }
        alert(data.message)
    };




    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')

    useEffect(() => {
        FetchCommunityDetail(1)
        FetchActivityData()
        FetchInvalidUsers()
    }, []);



    if (users.length == 0) {

        return <>

        </>

    }

    const formatTime = (seconds) => {
        if (seconds < 60) {
            return `${seconds}s`;
        }

        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;

        if (minutes < 60) {
            return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`;
        }

        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;

        if (hours < 24) {
            return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
        }

        const days = Math.floor(hours / 24);
        const remainingHours = hours % 24;

        return remainingHours > 0
            ? `${days}d ${remainingHours}h ${remainingMinutes}m`
            : `${days}d ${remainingHours}h`;
    };


    const getTimeSpentInCommunity = (userId) => {

        const currentActivityObj = userActivity.find(activity => activity.userId.toString() == userId)

        if (currentActivityObj) {
            return formatTime(currentActivityObj.totalTimeSpent)

        } else {
            return "-"
        }

    }

    const getTimeSpentTodayInCommunity = (userId) => {

        const currentActivityObj = userActivity.find(activity => activity.userId.toString() == userId)

        if (currentActivityObj) {
            return formatTime(currentActivityObj.todayTimeSpent) == "0s" ? "-" : formatTime(currentActivityObj.todayTimeSpent)

        } else {
            return "-"
        }

    }

    const getFormattedTime = (timeStamp) => {

        const isoString = timeStamp;
        const desiredFormat = "dd MMMM yyyy, hh:mm a";

        const indianTimeZone = "Asia/Kolkata";
        const zonedTime = utcToZonedTime(isoString, indianTimeZone);

        const formattedDate = format(zonedTime, desiredFormat, {
            timeZone: indianTimeZone,
        });

        return formattedDate;

    }

    const handleDateChange = (e) => {
        const { value } = e.target;
        //console.log("------", value)
        setSelectedDate(value);
        //const date = Convet_Date_To_Supported_Date(value)
        FetchActivityDataByDate(value)
    };
    const HandleDateClick = () => {
    };
    const HandleResetClick = () => {
        setSelectedDateMembers([])
        setSelectedDate(null);
    };

    const handleChange = (e) => {
        const { value } = e.target;
        setCommunityMail(value)
    };

    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>
                <Box
                    display={"flex"}
                    justifyContent="space-between"
                    alignItems={"center"}
                >
                    <Header
                        title={"Community Members"}
                        subtitle={`Activity of users in ${communityBasics.title}`}
                    />


                </Box>

                <Box
                    display={"flex"}
                    justifyContent="flex-start"
                    alignItems={"center"}
                >
                    <input
                        type="date"
                        name=""
                        id=""
                        value={selectedDate}
                        onChange={handleDateChange}
                        style={{
                            paddingLeft: "10px", paddingTop: '8px',
                            paddingRight: "10px", paddingBottom: '8px',
                            fontFamily: 'poppins-reg',
                            backgroundColor: "#ffffff00",
                            border: '1px solid #ffffff20',
                            color: '#ffffff',
                            borderRadius: '6px',
                            outline: 'none',
                            fontSize: "13px"
                        }}
                    />

                    <Button

                        style={{
                            width: 'max-content',
                            fontSize: "13px",
                            paddingLeft: "15px", paddingTop: '7px',
                            paddingRight: "15px", paddingBottom: '7px',
                            backgroundColor: "#ffffff15",
                            borderRadius: "6px",
                            border: "1px solid #ffffff25",
                            marginLeft: "10px",
                            textAlign: 'center',
                            fontFamily: 'poppins-reg',
                            textTransform: 'none'
                        }}
                        variant="contained"
                        onClick={HandleDateClick}

                    >
                        Search
                    </Button>
                    <Button
                        // startIcon={<Add />}
                        style={{
                            width: 'max-content',
                            fontSize: "13px",
                            paddingLeft: "15px", paddingTop: '7px',
                            paddingRight: "15px", paddingBottom: '7px',
                            backgroundColor: "#ffffff15",
                            borderRadius: "6px",
                            border: "1px solid #ffffff25",
                            marginLeft: "10px",
                            textAlign: 'center',
                            fontFamily: 'poppins-reg',
                            textTransform: 'none'
                        }}
                        variant="contained"
                        // component={Link}
                        // to="/admin/addenabledlocation"
                        onClick={HandleResetClick}
                    //   disabled={false}
                    >
                        ⟳ Reset
                    </Button>
                </Box>

                <Box sx={{ height: "1.5px", background: "#aaaaaa10", marginTop: "20px" }} />

                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'}>


                    <Box
                        display={"grid"}
                        gridTemplateColumns="repeat(12,1fr)"
                        gap="20px"
                        pb={"20px"}
                    >
                        <Box
                            display={"grid"}
                            gridColumn={isMobileScreen ? "span 12" : "span 8"}
                            gridTemplateColumns="repeat(12,1fr)"
                            gap="20px"
                            paddingY={"15px"}
                            pb={"20px"}>

                            <Box
                                display={"grid"}
                                gridColumn={"span 12"}
                                gridRow="span 2"
                                gridTemplateColumns="repeat(12,1fr)"
                                gap="20px"
                                paddingY={"15px"}
                                pb={"20px"}>

                                <Box
                                    // key={`${transaction.txId}-${i}`}
                                    gridColumn={isMobileScreen ? "span 12" : "span 4"}
                                    gridRow="span 2"
                                    display="flex"
                                    alignItems="center"
                                    px="15px"
                                    py={"8px"}

                                    sx={{
                                        background: "#ffffff08",
                                        borderRadius: "20px",
                                        border: "1.5px solid #ffffff10",
                                        textDecoration: 'none', paddingY: "30px", flexDirection: 'row',
                                        display: 'flex',
                                    }}>
                                    <Box sx={{
                                        width: "55px", height: "55px", borderRadius: "100px", background: "#ffffff10", justifyItems: 'center', alignItems: 'center',
                                        justifyContent: 'center', alignContent: 'center', display: 'flex', textDecoration: 'none'
                                    }}>

                                        <OnlinePredictionOutlined style={{ width: "25px", height: "25px", color: "#ffffff" }} />

                                    </Box>
                                    <Box sx={{ flex: 1, flexDirection: 'column', display: 'flex', marginLeft: "15px" }}>

                                        <Typography fontSize={"15px"} fontFamily={'poppins-reg'} color={colors.grey[300]}>
                                            Active {selectedDateMembers.length == 0 ? "Today" : "Members"}
                                        </Typography>

                                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "8px 0 0 0", display: 'flex' }}>
                                            <Typography
                                                fontSize={"20px"}
                                                color={colors.grey[100]}
                                                fontFamily={"poppins-mid"}
                                            >
                                                { selectedDateMembers.length > 0 ? selectedDateMembers.length :  activityStatus.success ? activityStatus.activeToday : 0}
                                            </Typography>


                                        </Box>


                                    </Box>

                                </Box>

                                <Box
                                    // key={`${transaction.txId}-${i}`}
                                    gridColumn={isMobileScreen ? "span 12" : "span 4"}
                                    gridRow="span 2"
                                    display="flex"
                                    alignItems="center"
                                    px="15px"
                                    py={"8px"}

                                    sx={{
                                        background: "#ffffff08",
                                        borderRadius: "20px",
                                        border: "1.5px solid #ffffff10",
                                        textDecoration: 'none', paddingY: "30px", flexDirection: 'row',
                                        display: 'flex',
                                    }}>
                                    <Box sx={{
                                        width: "55px", height: "55px", borderRadius: "100px", background: "#ffffff10", justifyItems: 'center', alignItems: 'center',
                                        justifyContent: 'center', alignContent: 'center', display: 'flex', textDecoration: 'none'
                                    }}>

                                        <CalendarMonthOutlined style={{ width: "25px", height: "25px", color: "#ffffff" }} />

                                    </Box>
                                    <Box sx={{ flex: 1, flexDirection: 'column', display: 'flex', marginLeft: "15px" }}>

                                        <Typography fontSize={"15px"} fontFamily={'poppins-reg'} color={colors.grey[300]}>
                                            Total Time Spent
                                        </Typography>

                                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "8px 0 0 0", display: 'flex' }}>
                                            <Typography
                                                fontSize={"20px"}
                                                color={colors.grey[100]}
                                                fontFamily={"poppins-mid"}
                                            >
                                                {activityStatus.success ? formatTime(activityStatus.totalTimeSpent) : formatTime(0)}
                                            </Typography>


                                        </Box>


                                    </Box>

                                </Box>

                                <Box
                                    // key={`${transaction.txId}-${i}`}
                                    gridColumn={isMobileScreen ? "span 12" : "span 4"}
                                    gridRow="span 2"
                                    display="flex"
                                    alignItems="center"
                                    px="15px"
                                    py={"8px"}

                                    sx={{
                                        background: "#ffffff08",
                                        borderRadius: "20px",
                                        border: "1.5px solid #ffffff10",
                                        textDecoration: 'none', paddingY: "30px", flexDirection: 'row',
                                        display: 'flex',
                                    }}>
                                    <Box sx={{
                                        width: "55px", height: "55px", borderRadius: "100px", background: "#ffffff10", justifyItems: 'center', alignItems: 'center',
                                        justifyContent: 'center', alignContent: 'center', display: 'flex', textDecoration: 'none'
                                    }}>

                                        <ClockIcon style={{ width: "25px", height: "25px", color: "#ffffff" }} />

                                    </Box>
                                    <Box sx={{ flex: 1, flexDirection: 'column', display: 'flex', marginLeft: "15px" }}>

                                        <Typography fontSize={"15px"} fontFamily={'poppins-reg'} color={colors.grey[300]}>
                                            Time Spent Today
                                        </Typography>

                                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "8px 0 0 0", display: 'flex' }}>
                                            <Typography
                                                fontSize={"20px"}
                                                color={colors.grey[100]}
                                                fontFamily={"poppins-mid"}
                                            >
                                                {formatTime(activityStatus.success ? activityStatus.todayTimeSpent : 0)}
                                            </Typography>


                                        </Box>


                                    </Box>

                                </Box>



                            </Box>



                            <Box
                                gridRow={'span 1'}
                                gridColumn={isMobileScreen ? 'span 12' : 'span 6'}
                                px="20px"
                                py={"20px"}
                                sx={{
                                    background: "#121319",
                                    borderRadius: "20px",
                                    flexDirection: 'column',
                                    display: 'flex'
                                }}>

                                <Typography fontSize={"14px"} fontFamily={'poppins-reg'} color={"#ffffff"} mb={"10px"}>
                                    Remove a user from community
                                </Typography>

                                <TextField value={communityMail} onChange={handleChange} placeholder="Enter community mail..." inputProps={{
                                    style: {
                                        paddingInline: "20px",
                                        outline: 'none'
                                    }
                                }} sx={{
                                    fontSize: "14px",
                                    "& .MuiInputLabel-root": {
                                        color: "#ffffff90",
                                        fontFamily: "poppins-reg",  // Change label font family
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": { borderColor: "#ffffff15", borderRadius: "10px", background: "#ffffff10" },
                                        "&:hover fieldset": { borderColor: "#ffffff15", borderRadius: "10px", background: "#ffffff10" },
                                        "&.Mui-focused fieldset": { borderColor: "#ffffff15", borderRadius: "10px", background: "#ffffff10" },
                                    },
                                    "& .MuiInputBase-input": {
                                        fontFamily: "poppins-reg", // Change font family
                                        fontSize: "14px", // Change font size
                                    },
                                }} />


                                <Box onClick={() => {

                                    if (communityMail == "") {
                                        alert("Please enter community mail of the user")
                                    } else {
                                        deleteUser(communityMail)
                                    }
                                    //deleteuser
                                }} marginTop={"20px"} sx={{
                                    display: 'flex', flexDirection: 'row', alignItems: 'center', border: "0.8px solid #ffffff50",
                                    borderRadius: "5px", background: "#ffffff20", paddingInline: "10px", paddingBlock: "4px", cursor: 'pointer',
                                    alignSelf: 'flex-start'
                                }}>

                                    <Typography fontSize={"13px"} fontFamily={'poppins-reg'} color={"#ffffff"} >
                                        Remove this user
                                    </Typography>
                                </Box>


                            </Box>


                            <Box
                                // key={`${transaction.txId}-${i}`}
                                gridColumn={'span 12'}
                                gridRow={'span 1'}
                                px="20px"
                                py={"20px"}
                                sx={{
                                    background: "#121319",
                                    borderRadius: "20px",
                                    overflow: 'scroll',
                                    textDecoration: 'none', flexDirection: 'column',
                                }}>


                                <Box
                                    gridTemplateColumns="repeat(12,1fr)"
                                    display={'grid'}
                                    gap={"20px"}
                                >

                                    {

                                        selectedDateMembers.length == 0 && users.map((item, index) => (
                                            <Box
                                                component={Link}
                                                key={item._id}
                                                gridColumn={isMobileScreen ? 'span 12' : 'span 6'}
                                                gridRow="span 1"
                                                px={"15px"}
                                                py={"15px"}
                                                to={{
                                                    pathname: "/admin/community/user/activity",
                                                    search: `?userid=${item.userId._id}&community=${query.get('community')}`,
                                                    state: { fromDashboard: true },
                                                    // console.log(first)
                                                }}
                                                sx={{
                                                    background: "#ffffff05",
                                                    display: 'flex',
                                                    borderRadius: "20px",
                                                    textDecoration: 'none',
                                                    flexDirection: 'column',
                                                }}
                                            >
                                                <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex' }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <img
                                                            alt="profile-user"
                                                            width="70px"
                                                            height="70px"
                                                            src={`${item.userId.image[0]}`}
                                                            style={{
                                                                cursor: "pointer", objectFit: 'contain',
                                                                borderRadius: "50%",
                                                                imageRendering: 'auto',
                                                                filter: "contrast(1) brightness(1)",
                                                                border: "5px solid #ffffff10"
                                                            }}
                                                        />
                                                    </Box>
                                                    <Box sx={{ flexDirection: 'column', display: 'flex', marginLeft: "15px", flex: 1 }}>
                                                        <Typography fontSize={"16px"} fontFamily={'poppins-reg'} color={"#ffffff"}>
                                                            {item.userId.full_name}
                                                        </Typography>
                                                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={"#ffffff70"}>
                                                            {item.userId.buzz_name}
                                                        </Typography>
                                                    </Box>

                                                    <Box onClick={() => {
                                                        navigator.clipboard.writeText(`${item.userId._id}`)
                                                        alert("User id has been copied to clipboard.")
                                                    }} sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                        <CopyAllOutlined sx={{ color: "white" }} />

                                                    </Box>
                                                </Box>

                                                <Box sx={{
                                                    height: "2px",
                                                    background: "#ffffff05",
                                                    marginBlock: "15px"
                                                }} />

                                                <Box
                                                    display={'grid'}
                                                    gridTemplateColumns="repeat(12,1fr)"
                                                    gap="20px"
                                                    paddingY={"15px"}
                                                    px={"20px"}
                                                    sx={{
                                                        borderRadius: "15px",
                                                        background: "#ffffff05",
                                                    }}>

                                                    <Box
                                                        // key={`${transaction.txId}-${i}`}
                                                        gridColumn={'span 6'}
                                                        gridRow={'span 1'}
                                                    >

                                                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={colors.grey[300]}>
                                                            Time Spent
                                                        </Typography>

                                                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "5px 0 0 0", display: 'flex' }}>
                                                            <Typography
                                                                fontSize={"14px"}
                                                                color={colors.grey[100]}
                                                                fontFamily={"poppins-reg"}
                                                            >
                                                                {getTimeSpentInCommunity(item.userId._id)}
                                                            </Typography>


                                                        </Box>

                                                    </Box>
                                                    <Box
                                                        // key={`${transaction.txId}-${i}`}
                                                        gridColumn={'span 6'}
                                                        gridRow={'span 1'}
                                                    >

                                                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={colors.grey[300]}>
                                                            Spent Today
                                                        </Typography>

                                                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "5px 0 0 0", display: 'flex' }}>
                                                            <Typography
                                                                fontSize={"14px"}
                                                                color={getTimeSpentTodayInCommunity(item.userId._id) == "-" ? "#ffffff" : "orange"}
                                                                fontFamily={"poppins-reg"}
                                                            >
                                                                {getTimeSpentTodayInCommunity(item.userId._id)}
                                                            </Typography>


                                                        </Box>

                                                    </Box>

                                                    <Box
                                                        // key={`${transaction.txId}-${i}`}
                                                        gridColumn={'span 12'}
                                                        gridRow={'span 1'}
                                                    >

                                                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={colors.grey[300]}>
                                                            Joined At
                                                        </Typography>

                                                        <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "5px 0 0 0", display: 'flex' }}>
                                                            <Typography
                                                                fontSize={"14px"}
                                                                color={"#ffffff"}
                                                                fontFamily={"poppins-reg"}
                                                            >
                                                                {getFormattedTime(item.createdAt)}
                                                            </Typography>


                                                        </Box>

                                                    </Box>

                                                </Box>


                                            </Box>
                                        ))
                                    }

                                    {

                                        selectedDateMembers.length > 0 && selectedDateMembers.map((item, index) => (
                                            <Box
                                                component={Link}
                                                key={item.userId}
                                                gridColumn={isMobileScreen ? 'span 12' : 'span 6'}
                                                gridRow="span 1"
                                                px={"15px"}
                                                py={"15px"}
                                                to={{
                                                    pathname: "/admin/community/user/activity",
                                                    search: `?userid=${item.userId}&community=${query.get('community')}`,
                                                    state: { fromDashboard: true },
                                                    // console.log(first)
                                                }}
                                                sx={{
                                                    background: "#ffffff05",
                                                    display: 'flex',
                                                    borderRadius: "20px",
                                                    textDecoration: 'none',
                                                    flexDirection: 'column',
                                                }}
                                            >
                                                <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex' }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <img
                                                            alt="profile-user"
                                                            width="70px"
                                                            height="70px"
                                                            src={`${item.image[0]}`}
                                                            style={{
                                                                cursor: "pointer", objectFit: 'contain',
                                                                borderRadius: "50%",
                                                                imageRendering: 'auto',
                                                                filter: "contrast(1) brightness(1)",
                                                                border: "5px solid #ffffff10"
                                                            }}
                                                        />
                                                    </Box>
                                                    <Box sx={{ flexDirection: 'column', display: 'flex', marginLeft: "15px", flex: 1 }}>
                                                        <Typography fontSize={"16px"} fontFamily={'poppins-reg'} color={"#ffffff"}>
                                                            {item.full_name}
                                                        </Typography>
                                                        <Typography fontSize={"12px"} fontFamily={'poppins-reg'} color={"#ffffff70"}>
                                                            {item.buzz_name}
                                                        </Typography>
                                                    </Box>

                                                    <Box onClick={() => {
                                                        navigator.clipboard.writeText(`${item.userId}`)
                                                        alert("User id has been copied to clipboard.")
                                                    }} sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                        <CopyAllOutlined sx={{ color: "white" }} />

                                                    </Box>
                                                </Box>



                                            </Box>
                                        ))
                                    }

                                </Box>


                                <Box onClick={() => {
                                    if (!hasEnded) {
                                        FetchCommunityDetail(currentPage + 1)
                                    }
                                }} sx={{
                                    paddingY: "15px", alignSelf: 'stretch', display: 'flex', textAlign: 'center', justifyContent: 'center',
                                    alignContent: 'center', flexDirection: 'column', cursor: 'pointer'
                                }}>
                                    <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px" }} >{hasEnded ? "- That's all for now -" : "- Load More -"}</Typography>
                                </Box>


                            </Box>

                        </Box>

                        <Box
                            display={"grid"}
                            gridColumn={isMobileScreen ? "span 12" : "span 4"}
                            gridTemplateColumns="repeat(12,1fr)"
                            gap="20px"
                            paddingY={"30px"}
                            pb={"20px"}>

                            <Box
                                // key={`${transaction.txId}-${i}`}
                                gridColumn={"span 12"}
                                gridRow="span 2"
                                display="flex"
                                alignItems="center"
                                px="15px"
                                py={"8px"}

                                sx={{
                                    background: "#ffffff08",
                                    borderRadius: "20px",
                                    border: "1.5px solid #ffffff10",
                                    textDecoration: 'none', paddingY: "30px", flexDirection: 'column',
                                    display: 'flex',
                                    height: "100vh",
                                    overflow: 'scroll',
                                    justifyContent: 'flex-start',
                                    alignItems: 'flex-start'
                                }}>

                                <Typography fontSize={"14px"} fontFamily={'poppins-reg'} color={"#ffffff"} marginBottom={"20px"}>
                                    {invalidUsers.length} Inactive or uninstalled users
                                </Typography>

                                <Box onClick={exportToExcel} marginBottom={"20px"} sx={{
                                    display: 'flex', flexDirection: 'row', alignItems: 'center', border: "0.8px solid #ffffff50",
                                    borderRadius: "5px", background: "#ffffff20", paddingInline: "10px", paddingBlock: "4px", cursor: 'pointer',
                                }}>

                                    <Typography fontSize={"13px"} fontFamily={'poppins-reg'} color={"#ffffff"} >
                                        Export Data
                                    </Typography>

                                    <DownloadOutlined style={{ color: "#ffffff", marginLeft: "5px", fontSize: "17px" }} />

                                </Box>


                                {
                                    invalidUsers.map((item, index) => (

                                        <Box
                                            // key={`${transaction.txId}-${i}`}

                                            display="flex"
                                            alignItems="center"
                                            px="15px"
                                            marginBottom={"10px"}
                                            py={"8px"}
                                            component={Link}
                                            backgroundColor={"#ffffff05"}
                                            target={"_blank"}
                                            borderRadius={"10px"}
                                            to={{
                                                pathname: "/admin/particularuserdetails",
                                                search: `?userid=${item.userId?._id}`,
                                                state: { fromDashboard: true },
                                                // console.log(first)
                                            }}

                                            sx={{
                                                textDecoration: 'none',
                                                alignSelf: 'stretch'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <img
                                                    alt="profile-user"
                                                    width="50px"
                                                    height="50px"
                                                    src={` ${item.userId?.image[0]}`}
                                                    style={{
                                                        cursor: "pointer", objectFit: 'cover',
                                                        borderRadius: "50%",
                                                        border: "5px solid #ffffff10"
                                                    }}
                                                />
                                            </Box>
                                            <Box sx={{ ml: "10px", display: 'flex', flexDirection: 'column', flex: 1 }}>
                                                <Typography color={"#ffffff"}
                                                    fontFamily={"poppins-reg"}
                                                    fontSize={"13px"}>{item.userId?.full_name}</Typography>

                                                <Typography color={"#ffffff90"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        alignSelf: "flex-start",
                                                        border: "1px solid #ffffff10",
                                                        borderRadius: "4px",
                                                        paddingTop: "1px",
                                                        marginTop: "1px",
                                                        paddingBottom: "1px",
                                                        paddingLeft: "6px",
                                                        paddingRight: "6px"
                                                    }}
                                                    fontSize={"10px"}>{item.userId?.buzz_name}</Typography>
                                            </Box>

                                            <Box sx={{ width: "5px", height: "5px", background: item.userId?.Active ? 'red' : '#ffffff20', borderRadius: "100px" }} />
                                        </Box>

                                    ))
                                }




                            </Box>


                        </Box>
                    </Box>


                </Box>

            </Box>
        </>
    );
};



export default CommunityMembers;
